<template>
  <Layout>
    <!-- <PageHeader v-if="title" :title="title" :items="items" /> -->

    <Loader :loading="loadingExport" no-axios>
      <balancing-show-drawer ref="balancing-show-drawer" @updated="refreshTable" @close="onDrawerClose"/>
      <div class="">
        <div v-if="stats.length" class="row">
          <div class="title">{{ lodash.upperCase(title) }}</div>
          <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass">
            <Stat v-bind="stat"/>
          </div>
        </div>
        <div v-if="!lodash.isEmpty(filterColumns)">
          <model-filter v-model="filter" :columns="filterColumns" :modelVariable="modelVariable"
                        :filterHandler="filterHandler"/>
        </div>
      </div>
      <div class="title">
        {{ lodash.upperCase($t('List')) }} {{ lodash.upperCase(title) }}
      </div>
      <div class="row">
        <model-index ref="table" class="col-12" :loading="loading" v-bind="$props" :columns="columns" :busy.sync="busy"
                     :models-paginated="modelsPaginated" :page.sync="page" :per-page.sync="perPage" :from="from"
                     :total="totalFiltered" :search.sync="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                     :filter-params.sync="filterParams" @create-click="handleCreate" @export-click="handleExport"
                     @show-click="handleShow" @edit-click="handleEdit" @delete-click="handleDelete">
        </model-index>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelFilter from '@/router/views/balancings/filter'
import ModelIndex from "../models/index-v3"
import icons from '@/assets/icons';
import DownPaymentFormExport from '@/components/modals/down-payment-form-export'
import JalaAppIcon from '@/assets/icons/JalaApp.svg'
import JalaHarvestIcon from '@/assets/icons/JalaHarvest.svg'
import JalaProIcon from '@/assets/icons/JalaPro.svg'
import StatusWidget from '@/components/widgets/statuses/status'
import StatusTonWidget from '@/components/widgets/statuses/status-with-ton'
import StatusDateWidget from '@/components/widgets/statuses/status-with-date'
import BalancingShowDrawer from "@/components/drawers/balancing-show-drawer.vue";

/* eslint-disable vue/no-unused-components */
export default {
  extends: ModelIndex,
  components: {
    BalancingShowDrawer,
    ModelFilter,
    DownPaymentFormExport,
    icons,
    JalaAppIcon,
    JalaHarvestIcon,
    JalaProIcon,
    StatusWidget,
    StatusTonWidget,
    StatusDateWidget,
  },
  page: {
    title: "Purchase Orders",
  },
  props: {
    resourceRoute: {default: 'balancings'},
    modelVariable: {default: 'balancing'},
    denyCreate: {
      type: Boolean, default() {
        return true;
      }
    },
    tableProps: {
      default(){
        return {
          "tbody-tr-class": function(item, type){
            if(!item || !type) return;
            if(item._highlight){
              return 'table-row-highlight';
            }
          }
        }
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('balancings.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('balancings.singular')),
          href: "/balancings",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        'ticket.customer_type': {
          type: String,
          label: this.lodash.upperFirst(this.$t('balancings.customer_type')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('balancings.customer_type')),
          operator: 'in',
          input_component: 'customer-type-select',
        },
        id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('balancings.id')),
          params: {
            sort: 'id,desc',
            select: 'id',
            total_debt__gt: 0,
          },
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('balancings.id')),
          operator: 'in',
          input_component: 'balancing-multiselect-ajax',
          searchKey: 'id',
        },
        shrimp_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('products.singular')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('products.singular')),
          operator: 'in',
          input_component: 'product-service-multiselect-ajax',
          params: {
            customer_type__contains: 'lcs',
          },
        },
        ordered_at__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('balancings.ordered_at')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('balancings.ordered_at')),
          operator: 'between',
          input_component: 'datepicker-range',
        },
        customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('purchase_orders.partner')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('purchase_orders.partner')),
          operator: 'in',
          input_component: 'supplier-multiselect-ajax',
        },
        'payment_status': {
          type: String,
          label: this.lodash.startCase('Status Pembayaran'),
          placeholder: "Pilih " + this.lodash.startCase('Status Pembayaran'),
          input_component: 'balancing-status-select',
        },
      },
      model: this.modelVariable
    }
  },
  computed: {
    columns() {
      return {
        ['balancing']: [
          {
            key: 'sale_order.ticket_id',
            label: this.lodash.startCase(this.$t('balancings.ticket_id')),
            thStyle: {width: '100px'},
            tdClass: 'align-middle',
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/tickets/${item.sale_order.ticket_id}`">{{ item.sale_order.ticket_id }}</router-link>'
            }
          },
          {
            key: 'id',
            label: this.lodash.startCase(this.$t('balancings.id')),
            thStyle: {width: '140px'},
            tdClass: 'align-middle',
            sortable: true,
          },
          {
            key: 'sale_order.id',
            label: this.lodash.startCase(this.$t('balancings.sale_order_id')),
            thStyle: {width: '140px'},
            tdClass: 'align-middle',
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/unloads/${item.sale_order.id}`">{{ item.sale_order.id }}</router-link>'
            }
          },
          {
            key: 'sale_order.ordered_at',
            label: this.lodash.startCase(this.$t('balancings.unloaded_at')),
            thStyle: {minWidth: '160px'},
            tdClass: 'align-middle',
            sortable: true,
            formatter: (value) => {
              return this.$moment.utc(value).local().format('DD MMM YYYY')
            }
          },
          {
            key: 'customer',
            label: this.lodash.startCase(this.$t('balancings.partner')),
            tdClass: 'align-middle',
            sortable: false,
            component: {
              props: ['item'],
              template: '<router-link :to="`/customers/${item.customer.id}`">{{ item.customer.name }}</router-link>'
            }
          },
          {
            key: 'manufacture',
            label: this.lodash.startCase(this.$t('balancings.manufacture')),
            tdClass: 'align-middle',
            sortable: false,
            component: {
              props: ['item'],
              template: '<router-link :to="`/customers/${item.manufacture.id}`">{{ item.manufacture.name }}</router-link>'
            }
          },
          {
            key: 'total_debt',
            label: this.lodash.startCase(this.$t('balancings.nominal')),
            thStyle: {minWidth: '180px'},
            tdClass: 'align-middle',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(Math.abs(value)).format('$ 0,0')
            }
          },
          {
            key: 'sale_order.sale_item_total_quantity',
            label: this.lodash.startCase(this.$t('balancings.unloaded_quantity')),
            thStyle: {minWidth: '140px'},
            tdClass: 'align-middle',
            sortable: true,
            formatter: (value) => {
                return value >= 500 ? `${this.$numeral(value / 1000).format('0,0.[000]')} ${this.$t('ton')}` :
                    `${this.$numeral(value).format('0,0.[000]')} ${this.$t('units.kg')}`
            }
          },
          {
            key: 'status',
            label: this.lodash.startCase(this.$t('balancings.payment_status')),
            thStyle: {minWidth: '120px'},
            tdClass: 'align-middle',
            sortable: false,
            component: {
              props: ['item'],
              computed: {
                label() {
                  return this.lodash.upperFirst(this.$t(`balancings.payment_statuses.${this.item.state}`))
                },
                style(){
                  if (this.item.state === 'paid' || this.item.state === 'partial') {
                    return 'text-success'
                  } else if (this.item.state === 'in_payment') {
                    return 'text-warning'
                  }
                  return 'text-danger'
                },
              },
              template: `
                <div><span v-html="label" :class="style"></span></div>
              `
            }
          },
        ],
      };
    },
  },
  methods: {
    refreshTable(){
      this.$refs.table.$refs.table.refresh()
    },
    handleShow(value) {
      this.clearHighlight();
      const modelIndex = this.models?.findIndex((model) => model.id === value.id);
      if(modelIndex !== -1){
        this.$set(this.models[modelIndex], '_highlight', true);
      }
      this.$refs["balancing-show-drawer"].show(value.id);
    },
    clearHighlight(){
      this.models.filter((model) => model._highlight).forEach((model) => this.$set(model, '_highlight', false));
    },
    onDrawerClose(){
      setTimeout(() => {
        if(!this.$refs["balancing-show-drawer"].open){
          this.clearHighlight();
        }
      }, 300)
    },
    getModelName(value) {
      return value['id'];
    },
    fetchModels(page = 1) {
      return this.$axios.get('/balancing_transactions', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          withAggregate: true,
          with: [
            'sale_order',
            'customer',
            'profit_share',
            'manufacture',
            'balancing_payments',
          ].join(','),
          with_count: 'balancing_payments',
          total_debt__gt: 0,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.$route.params,
          ...this.filterParams
        }
      }).then((response) => {
        const {data: {data, meta}} = response;

        this.models = data.map((datum) => {
          return {
            ...datum,
          }
        })

        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.$nextTick(() => {
          const {
            balancing_show__id,
          } = this.$route.query;
          if(balancing_show__id){
            this.handleShow({
              id: balancing_show__id
            })
          }
        })

        return response;
      }).catch((error) => this.failedAlert(error));
    },
  },
  mounted() {
    window.addEventListener('click', function () {
      const highlightedRows = document.querySelectorAll('.highlighted-row')
      highlightedRows.forEach((el) => {
        el.classList.remove('highlighted-separator', 'highlighted-row')
      })
    })
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .page-content {
    background: #EEF3F7 !important;
    font-family: Lato;
    color: #161B4D;
  }

  .text-right {
    text-align: right;
  }
}

</style>
<style>
body {
  max-width: 100vw !important;
  overflow-x: hidden !important;
}

.highlighted-row {
  background: #EEF3F7;
}

.highlighted-separator {
  border-bottom: 1px solid #1B77DF;
  position: relative;

  .separator-badge {
    &::before {
      content: 'baru ditambahkan';
      position: absolute;
      bottom: -22px;
      border-radius: 0px 0px 4px 4px;
      background: #1B77DF;
      color: white;
      text-align: center;
      padding: 2px 5px;
    }
  }
}

.highlighted-separator-badge {
  position: absolute;
  top: 100px;
  left: 100px;
  background: blue;
}

</style>

<style lang="scss" scoped>
  ::v-deep {
    .table-model {
      thead {
        tr th {
          color: var(--neutral-700, var(--colors-slate-700, #334155));
          font-size: 13px;
          font-style: normal;
          font-weight: 600;
          line-height: 18px; /* 138.462% */
        }
      }

      .table-row-highlight{
        background: #F1F5F9;
      }
      tbody tr {
        *{
          font-size: 14px !important;
        }
      }
    }
  }
</style>